// src/layouts/StartPage.tsx
//
// The "/" route: sends the user to their start page (resolveStartRoute).
// Waits for the preferences and the v2 property list, so the choice is never
// made on the defaults and a user whose only pages are v2 screens is not
// sent away before the list arrives.
import React from 'react';
import { Navigate } from 'react-router-dom';
import { LoadingState } from '@/components/common/LoadingState';
import { usePreferences } from '@/providers/preferencesProvider';
import { useV2Properties } from '@/hooks/useV2PropertySelection';
import { withCheckinOrSurveyData } from '@/lib/v2Properties';
import { useHasDispensers } from '@/hooks/useHasDispensers';
import { getVisibleNavGroups, resolveStartRoute } from './menuStructure';

export const StartPage: React.FC = () => {
  const { preferences, loading } = usePreferences();
  const { data: v2Properties, isPending } = useV2Properties();
  const { data: surveyProperties } = useV2Properties(withCheckinOrSurveyData);
  // Not waited for: no start page is «Dispensadores», it only joins the list once known.
  const hasDispensers = useHasDispensers();

  if (loading || isPending) return <LoadingState />;

  const groups = getVisibleNavGroups((v2Properties?.length ?? 0) > 0, hasDispensers, (surveyProperties?.length ?? 0) > 0);
  const route = resolveStartRoute(`/${preferences.landingPage}`, groups);
  return <Navigate to={route ?? '/not-authorized'} replace />;
};

export default StartPage;
